import React, { useContext, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { CompanyContext } from '../../context/CompanyContext';

export default function CompanyNavbar() {
	const { company, logoutCompany } = useContext(CompanyContext);
	const [menuOpen, setMenuOpen] = useState(false);
	const navigate = useNavigate();
	const linkClass = ({ isActive }) => `px-3 py-2 rounded-md text-sm ${isActive ? 'text-blue-700' : 'text-gray-700 hover:text-blue-700'}`;
	return (
		<nav className="bg-white border-b">
			<div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between">
				<div className="flex items-center gap-4">
					<div className="text-xl font-bold text-blue-700 cursor-pointer" onClick={() => navigate('/company/dashboard')}>Resumly HR</div>
					<div className="hidden md:flex items-center gap-2">
						<NavLink to="/company/dashboard" className={linkClass}>Dashboard</NavLink>
						<NavLink to="/company/jobs" className={linkClass}>Jobs</NavLink>
						<NavLink to="/company/resumes" className={linkClass}>Candidates</NavLink>
						<NavLink to="/company/analytics" className={linkClass}>Analytics</NavLink>
					</div>
				</div>
				<div className="relative">
					<button onClick={() => setMenuOpen((v) => !v)} className="px-3 py-2 rounded hover:bg-gray-100 text-sm">
						{company?.companyName || 'Company'}
					</button>
					{menuOpen && (
						<div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow">
							<button className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50" onClick={() => { setMenuOpen(false); navigate('/company/profile'); }}>Company Profile</button>
							<button className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50" onClick={() => { setMenuOpen(false); navigate('/company/settings'); }}>Settings</button>
							<button className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 text-red-600" onClick={logoutCompany}>Logout</button>
						</div>
					)}
				</div>
			</div>
		</nav>
	);
}


